module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/wiktoria-tulodziecka-06217d6507f9453952ff9643984bd1d3.png";